import { object, string, number, boolean } from '@gogame/schemas';

import {
  FILTERS,
  TABLE_SETTINGS,
  SEARCH_QUERY,
} from 'scenes/SpendAdjustments/constants';

import { columnsSchema } from './columnsSchema';
import { filtersGaSchema } from './filtersSchema';
import { tableSettingsSchema } from './tableSettingsSchema';

export const screenSchema = object({
  [FILTERS]: filtersGaSchema,
  [TABLE_SETTINGS]: tableSettingsSchema,
  [SEARCH_QUERY]: string(),
  presetId: number(),
  columns: columnsSchema,
  ready: boolean().default(true),
});

export const mapPresetToState = (presetData) =>
  screenSchema.cast(presetData, { parseConst: true, context: {} });
